import type { PayV2Entity, PayV2Req } from '@revelio/data-access';

import {
  type Filter,
  FilterType,
  type PrimaryFilterId,
} from '../types/filters';
import {
  getV2Filters,
  positionsEntityLookup,
  V2DateGranularity,
} from './getV2Filters';

export const CompensationDateGranularity = V2DateGranularity;

export const getCompensationV2Entities = ({
  primaryDimension,
  effectiveFilters,
}: {
  primaryDimension: PrimaryFilterId;
  effectiveFilters: Filter[];
}): PayV2Entity[] => {
  const primaryFilter = effectiveFilters.find(
    (filter) => filter.id === primaryDimension
  );

  if (!primaryFilter || primaryFilter.type !== FilterType.TREE) return [];

  return primaryFilter.selections
    .map((selection): PayV2Entity | null => {
      const entityType = positionsEntityLookup[selection.levelId];

      if (!entityType) return null;

      return {
        EntType: entityType,
        // biome-ignore lint/correctness/useParseIntRadix: migrated from develop
        EntID: parseInt(selection.id.split('_').slice(-1)[0] ?? ''),
      };
    })
    .filter((selection) => selection !== null);
};

export const getCompensationV2Filters = ({
  primaryDimension,
  effectiveFilters,
  isSnapshot = false,
}: {
  primaryDimension: PrimaryFilterId;
  effectiveFilters: Filter[];
  isSnapshot?: boolean;
}): PayV2Req => {
  const entities = getCompensationV2Entities({
    primaryDimension,
    effectiveFilters,
  });

  const filters = getV2Filters({
    primaryDimension,
    effectiveFilters,
    isSnapshot,
  });

  return { entities, filters };
};
